import React from 'react';
import { useGlobal, setGlobal } from 'reactn';
import { Redirect } from 'react-router-dom';
import { Checkbox } from 'antd';
import Dropdown from '../../common/dropdown/Dropdown';

import api from '../../../api';

import './SvcAccountHeader.scss';

const SvcAccountHeader = () => {
  const [serviceAccounts] = useGlobal('serviceAccounts');
  const [defaultAccountNumber] = useGlobal('defaultAccountNumber');
  const [
    selectedServiceAccountIndex,
    setSelectedServiceAccountIndex,
  ] = useGlobal('selectedServiceAccountIndex');
  const [user] = useGlobal('user');

  if (user === null) {
    return <Redirect to="/auth/signin" />;
  }
  const { first_name } = user;
  const selectedServiceAccount = serviceAccounts[selectedServiceAccountIndex];

  if (selectedServiceAccount === undefined) {
    return <h4>SERVICE ACCOUNT UNAVAILABLE</h4>;
  }

  const handleSetDefaultProperty = async (accountNo) => {
    try {
      await api.setDefaultProperty(accountNo);
    } catch (error) {
      console.log(error.response?.data);
    }
  };

  const {
    ACCOUNT,
    NAME_LINE1,
    SA_STRNUM,
    SA_STRNAME,
    SA_CITY,
    SA_STATE,
    SA_ZIP_CODE,
  } = selectedServiceAccount.data;

  return (
    <div className="w-full bg-blue-dark py-8 text-white">
      <div className="container mx-auto px-1 lg:px-0">
        <div className="flex flex-wrap justify-between">
          <div className="flex flex-wrap items-start w-full p-8 lg:p-4">
            <h3
              className="w-full lg:w-1/4 text-4xl pr-4 pb-4 lg:pb-0 text-white"
              style={{ fontFamily: 'Oswald, sans-serif', fontSize: '2.63rem' }}
            >
              Welcome, {first_name}
            </h3>
            <div className="flex flex-col w-full lg:w-1/4 pr-4">
              <p className="my-auto text-md font-bold">Account Number:</p>
              <p className="my-auto text-md">{ACCOUNT}</p>
            </div>
            <div className="w-full lg:w-1/4 pr-4">
              <p className="text-md font-bold">Service Address:</p>
              <span className="text-md block">{NAME_LINE1 || ''}</span>
              <span className="text-md block">
                {`${SA_STRNUM || ''} ${SA_STRNAME || ''}`}
              </span>
              {SA_CITY && SA_STATE && SA_ZIP_CODE && (
                <span className="text-md block">
                  {`${SA_CITY}, ${SA_STATE}, ${SA_ZIP_CODE}`}
                </span>
              )}
            </div>
            <div className="w-full lg:w-1/4 pt-4 lg:pt-0">
              {serviceAccounts && serviceAccounts.length > 1 && (
                <>
                  <Dropdown
                    label="Switch Property:"
                    options={serviceAccounts.map((serviceAccount, idx) => ({
                      value: idx,
                      label: serviceAccount.data.ACCOUNT,
                    }))}
                    defaultValue={selectedServiceAccountIndex}
                    onChange={(selectedIndex) => {
                      setSelectedServiceAccountIndex(selectedIndex);
                    }}
                  />
                  <div>
                    <Checkbox
                      className="default-property-checkbox flex mt-2 items-center"
                      checked={
                        parseInt(defaultAccountNumber, 10) === ACCOUNT
                          ? true
                          : false
                      }
                      disabled={
                        parseInt(defaultAccountNumber, 10) === ACCOUNT
                          ? true
                          : false
                      }
                      onChange={() => {
                        handleSetDefaultProperty(ACCOUNT);
                        setGlobal({ defaultAccountNumber: ACCOUNT });
                      }}
                    >
                      <p className="text-white">
                        {parseInt(defaultAccountNumber, 10) === ACCOUNT
                          ? 'Default Property'
                          : 'Set Default Property'}
                      </p>
                    </Checkbox>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SvcAccountHeader;
